import Manager from './manager.vue';

import Product from './product.vue';

import OrderManager from './orderManager.vue';

import Summary from './steps/summary.vue';
import Information from './steps/information.vue';
import Delivery from './steps/delivery.vue';
import Approve from './steps/approve.vue';
import OrderComplete from './steps/completedOrder.vue';
import OrderFailed from './steps/failedOrder.vue';
import CardFailed from './steps/failedCard.vue';

export const routes = [


    {path: '/productless/order', name: 'make-productless-order.manage', component: Manager, children: [
        {path: 'product', name:'make-productless-order.product', component:Product},

        {path: 'order', name:'make-productless-order.order', component:OrderManager, redirect: {name: 'make-productless-order.order.summary'},
            children:[
                { path:'summary', name:'make-productless-order.order.summary', component:Summary },
                { path:'information', name:'make-productless-order.order.information', component:Information },
                { path:'delivery', name:'make-productless-order.order.delivery', component:Delivery },
                { path:'approve', name:'make-productless-order.order.approve', component:Approve },
            ]},

        {path: 'order/complete', name:'make-productless-order.order.complete', component:OrderComplete},
        {path: 'order/failed', name:'make-productless-order.order.failed', component:OrderFailed},
        {path: 'order/card/failed', name:'make-productless-order.order.card.failed', component:CardFailed},
    ]},

];
